export const getPartnersPageQuery = () => {
  const brandQueryTag = document.getElementById('searchContent');
  if (brandQueryTag != null) {
    return brandQueryTag?.dataset?.query || '';
  }
  return '';
};
